"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var oss_1 = __importDefault(require("./lib/oss"));
var cos_1 = __importDefault(require("./lib/cos"));
var obs_1 = __importDefault(require("./lib/obs"));
/**
 * 已适配的云服务商
 */
exports.CloudServer = {
    oss: oss_1.default,
    cos: cos_1.default,
    obs: obs_1.default
};
/**
 * 数据处理扩展参数
 */
var CloudType;
(function (CloudType) {
    CloudType["oss"] = "oss";
    CloudType["cos"] = "cos";
    CloudType["obs"] = "obs";
})(CloudType = exports.CloudType || (exports.CloudType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZmlnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbmZpZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLGtEQUEyQjtBQUMzQixrREFBMkI7QUFDM0Isa0RBQTJCO0FBRTNCOztHQUVHO0FBQ1UsUUFBQSxXQUFXLEdBQUc7SUFDekIsR0FBRyxFQUFFLGFBQUc7SUFDUixHQUFHLEVBQUUsYUFBRztJQUNSLEdBQUcsRUFBRSxhQUFHO0NBQ1QsQ0FBQTtBQUVEOztHQUVHO0FBQ0gsSUFBWSxTQUlYO0FBSkQsV0FBWSxTQUFTO0lBQ25CLHdCQUFXLENBQUE7SUFDWCx3QkFBVyxDQUFBO0lBQ1gsd0JBQVcsQ0FBQTtBQUNiLENBQUMsRUFKVyxTQUFTLEdBQVQsaUJBQVMsS0FBVCxpQkFBUyxRQUlwQiJ9